import * as React from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import * as api from '../../api';

import { SelectInput } from '../SelectInput';
import { getOptionsFromRecord } from '../utils';
import ContextualHelpModal from '../ContextualHelpModal';
import InfoLabel from '../ContextualHelpModal/InfoLabel';

import styles from './index.module.css';

interface Props {
  religionOptions: api.Patient.Religion[];
  required: boolean;
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
  value: string;
}
const DefaultReligions = {
  [api.Patient.Religion.Amish]: api.Previsit.religionMap.AMISH,
  [api.Patient.Religion.Agnostic]: api.Previsit.religionMap.AGNOSTIC,
  [api.Patient.Religion.Buddhist]: api.Previsit.religionMap.BUDDHIST,
  [api.Patient.Religion.Catholic]: api.Previsit.religionMap.CATHOLIC,
  [api.Patient.Religion.Christian]: api.Previsit.religionMap.CHRISTIAN,
  [api.Patient.Religion.ChristianScientists]:
    api.Previsit.religionMap.CHRISTIAN_SCIENTISTS,
  [api.Patient.Religion.Hindu]: api.Previsit.religionMap.HINDU,
  [api.Patient.Religion.JehovasWitness]:
    api.Previsit.religionMap.JEHOVAS_WITNESS,
  [api.Patient.Religion.Jewish]: api.Previsit.religionMap.JEWISH,
  [api.Patient.Religion.Mormon]: api.Previsit.religionMap.MORMON,
  [api.Patient.Religion.Muslim]: api.Previsit.religionMap.MUSLIM,
  [api.Patient.Religion.OrthodoxJews]: api.Previsit.religionMap.ORTHODOX_JEWS,
  [api.Patient.Religion.Other]: api.Previsit.religionMap.OTHER,
  [api.Patient.Religion.PreferNotToAnswer]:
    api.Previsit.religionMap.PREFER_NOT_TO_ANSWER,
  [api.Patient.Religion.SeventhDayAdventists]:
    api.Previsit.religionMap.SEVENTH_DAY_ADVENTISTS,
  [api.Patient.Religion.Sikhs]: api.Previsit.religionMap.SIKHS,
};

export function ReligionInput(props: Props) {
  const { religionOptions, required, saveFieldValue, updateFieldValue, value } =
    props;
  const { t } = useTranslation();
  const [showHelp, setShowHelp] = React.useState(false);

  const displayOptions = religionOptions.length
    ? _.pick(api.Previsit.religionMap, religionOptions)
    : DefaultReligions;

  const religionValues = getOptionsFromRecord(displayOptions, t);

  return (
    <>
      <SelectInput
        value={value}
        isOptional={!required}
        onChange={(option: string) => {
          updateFieldValue(option);
          saveFieldValue(option);
        }}
        options={religionValues}
      />
      <div className={styles.InfoLabel}>
        <ContextualHelpModal
          headerText={t('Why are you asking me this?')}
          helpText={t('religionContextualHelp')}
          isOpen={showHelp}
          onRequestClose={() => setShowHelp(false)}
          onHandleHelpful={async () => setShowHelp(false)}
        />
        <InfoLabel
          onClick={() => setShowHelp(true)}
          label={t('Why are you asking me this?')}
        />
      </div>
    </>
  );
}
